var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',{staticStyle:{"flex":"1","margin-left":"24px"}},[_vm._v(" 供需论坛 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }